import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';
import { linkNodeToJsxPrinter } from './printers.to-jsx/common.links.js';
import { linkNodeToPaperPrinter } from './printers.to-paper/common.links.js';

function makeThrowPrinter(tagName) {
  return () => {
    throw new Error(
      `ContentEnginePrinterProvider(): printer not provided for '${tagName}'`
    );
  };
}
const PrinterContext = createContext({
  printers: {
    "accordion-component": makeThrowPrinter("accordion-component"),
    "audio-component": makeThrowPrinter("audio-component"),
    "cards-component": makeThrowPrinter("cards-component"),
    "empty-image-component": makeThrowPrinter("empty-image-component"),
    "grid-component": makeThrowPrinter("grid-component"),
    "iframe-component.component-framework": makeThrowPrinter(
      "iframe-component.component-framework"
    ),
    "iframe-component": makeThrowPrinter("iframe-component"),
    "image-component": makeThrowPrinter("image-component"),
    "slider-component": makeThrowPrinter("slider-component"),
    "text-component": makeThrowPrinter("text-component"),
    "23-video-component": makeThrowPrinter("23-video-component"),
    "cta-component": makeThrowPrinter("cta-component"),
    "component-framework.i-guide": makeThrowPrinter(
      "component-framework.i-guide"
    ),
    "component-framework.flashcard": makeThrowPrinter(
      "component-framework.flashcard"
    ),
    "component-framework.geogebra": makeThrowPrinter(
      "component-framework.geogebra"
    ),
    "component-framework.i-ark": makeThrowPrinter("component-framework.i-ark"),
    "component-framework.opgavekomplekset": makeThrowPrinter(
      "component-framework.opgavekomplekset"
    ),
    "component-framework.image-hotspots": makeThrowPrinter(
      "component-framework.image-hotspots"
    ),
    "component-framework.error": makeThrowPrinter("component-framework.error"),
    link: linkNodeToJsxPrinter
  },
  paperPrinters: {
    "accordion-component": makeThrowPrinter("accordion-component"),
    "audio-component": makeThrowPrinter("audio-component"),
    "cards-component": makeThrowPrinter("cards-component"),
    "empty-image-component": makeThrowPrinter("empty-image-component"),
    "grid-component": makeThrowPrinter("grid-component"),
    "iframe-component.component-framework": makeThrowPrinter(
      "iframe-component.component-framework"
    ),
    "iframe-component": makeThrowPrinter("iframe-component"),
    "image-component": makeThrowPrinter("image-component"),
    "slider-component": makeThrowPrinter("slider-component"),
    "text-component": makeThrowPrinter("text-component"),
    "23-video-component": makeThrowPrinter("23-video-component"),
    "cta-component": makeThrowPrinter("cta-component"),
    "component-framework.i-guide": makeThrowPrinter(
      "component-framework.i-guide"
    ),
    "component-framework.flashcard": makeThrowPrinter(
      "component-framework.flashcard"
    ),
    "component-framework.geogebra": makeThrowPrinter(
      "component-framework.geogebra"
    ),
    "component-framework.i-ark": makeThrowPrinter("component-framework.i-ark"),
    "component-framework.opgavekomplekset": makeThrowPrinter(
      "component-framework.opgavekomplekset"
    ),
    "component-framework.image-hotspots": makeThrowPrinter(
      "component-framework.image-hotspots"
    ),
    "component-framework.error": makeThrowPrinter("component-framework.error"),
    link: linkNodeToPaperPrinter
  },
  interceptor: void 0
});
function ContentEnginePrinterProvider(props) {
  const parentContext = useContentEnginePrinters();
  const value = useMemo(
    () => ({
      printers: {
        ...parentContext.printers,
        ...props.printers
      },
      paperPrinters: {
        ...parentContext.paperPrinters,
        ...props.paperPrinters
      },
      interceptor: props.interceptor ?? parentContext.interceptor
    }),
    [
      parentContext.interceptor,
      parentContext.paperPrinters,
      parentContext.printers,
      props.interceptor,
      props.paperPrinters,
      props.printers
    ]
  );
  return /* @__PURE__ */ jsx(PrinterContext.Provider, { value, children: props.children });
}
function useContentEnginePrinters() {
  return useContext(PrinterContext);
}

export { ContentEnginePrinterProvider, PrinterContext, useContentEnginePrinters };
//# sourceMappingURL=core.printer-provider.js.map
